import { api } from './api';

export const disputesService = {
    list: (status = 'open') => api.get(`/api/admin/disputes?status=${status}`),
    forService: (serviceId) => api.get(`/api/admin/services/${serviceId}/disputes`),
    update: (id, body) => api.patch(`/api/admin/disputes/${id}`, body),
};
